module.exports = __webpack_public_path__ + "img/qiancai-back-code@3x.86b152e2.png";